import React from 'react';
import { Body } from '@leafygreen-ui/typography';
import { PropsWithChildren } from 'react';
import { StepLabelProps, StepStates } from './types';
import { palette } from '@leafygreen-ui/palette';
import { css, cx } from '@leafygreen-ui/emotion';
import { useStepperContext } from './StepperContext';
import { stepLabelClassName } from './constants';

const StepLabel = ({ children, state }: PropsWithChildren<StepLabelProps>) => {
  const isCurrent = state === StepStates.Current;
  const { isDarkMode } = useStepperContext();

  const completedMultipleStyles = css`
    color: ${isDarkMode ? palette.green.base : palette.green.dark2};
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-underline-position: under;
  `;

  const completedStyles = css`
    color: ${isDarkMode ? palette.green.base : palette.green.dark2};
  `;

  const currentStyles = css`
    color: ${isDarkMode ? palette.gray.light2 : palette.green.dark3};
  `;

  const upcomingStyles = css`
    color: ${isDarkMode ? palette.gray.light1 : palette.gray.dark1};
  `;

  const upcomingMultipleStyles = css`
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-underline-position: under;
    color: ${isDarkMode ? palette.gray.light1 : palette.gray.dark1};
  `;

  const styles: Record<StepStates, string> = {
    [StepStates.CompletedMultiple]: completedMultipleStyles,
    [StepStates.Completed]: completedStyles,
    [StepStates.Current]: currentStyles,
    [StepStates.Upcoming]: upcomingStyles,
    [StepStates.UpcomingMultiple]: upcomingMultipleStyles,
  };

  return (
    <Body
      className={cx(styles[state], stepLabelClassName)}
      weight={isCurrent ? 'medium' : 'regular'}
    >
      {/*
        TODO: Would prefer to use a centralized font-weight value directly in css so it's not dependent on a ternary operator.
        Currently using the <Body> component with the `weight` prop since this is currently the only way to use a reusable variable.
      */}
      {children}
    </Body>
  );
};

export default StepLabel;
